import {Component} from '@angular/core';

@Component({
  selector: 'app-resource-image',
  templateUrl: './resource-image.component.html',
  styleUrls: ['./resource-image.component.css']
})
export class ResourceImageComponent {
  data: any
}
